// app/javascript/controllers/product_card_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "content" ]

  connect() {
    console.log("ProductCardController connected", this.element);
    console.log("Content target:", this.contentTarget);
  }

  toggle() {
    console.log("Toggle method called");
    console.log("Content target before toggle:", this.contentTarget);
    console.log("Hidden class present before toggle:", this.contentTarget.classList.contains("hidden"));
    
    this.contentTarget.classList.toggle("hidden")
    
    console.log("Content target after toggle:", this.contentTarget);
    console.log("Hidden class present after toggle:", this.contentTarget.classList.contains("hidden"));
    
    const button = this.element.querySelector("button")
    button.textContent = this.contentTarget.classList.contains("hidden") ? "Mehr Informationen" : "Schließen"
    console.log("Button text updated to:", button.textContent);
  }
}